import { useCSSInsertion } from "./use-css-insertion"

function useDefaultStylesReset(className: string): void {
    useCSSInsertion({
        cssString: `
            .${className} p, 
            .${className} h1, 
            .${className} h2, 
            .${className} h3, 
            .${className} h5,
            .${className} h6 { margin-bottom: 0px; }    
        `
    })
}

export { useDefaultStylesReset }
